import { useSessionStore } from '../auth/session-store'

import { RealtimeManager } from './manager'

/**
 * Shared app connection. The token is read at auth-frame time from the
 * in-memory store, never persisted or logged.
 */
export const realtimeManager = new RealtimeManager({
  getAccessToken: () => useSessionStore.getState().accessToken,
})
